export default __webpack_public_path__ + "static/media/traffic_type.82428f76.svg";